import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { navScreens, visibleNavItems } from '../navigation';
import { useFeatureFlags } from '../context/FeatureFlagsContext';

interface SidebarProps {
  collapsed: boolean;
}

export default function Sidebar({ collapsed }: SidebarProps) {
  const location = useLocation();
  const { isSuperAdmin, hasScreen } = useAuth();
  const features = useFeatureFlags();
  const visibleItems = visibleNavItems(isSuperAdmin, hasScreen, features);

  return (
    <aside className={`admin-sidebar${collapsed ? ' collapsed' : ''}`}>
      <div className="admin-sidebar-brand">
        <div className="admin-sidebar-brand-icon">G</div>
        <span className="admin-sidebar-brand-text">Garagat Admin</span>
      </div>

      <nav className="admin-sidebar-nav">
        <div className="admin-nav-section">
          <div className="admin-nav-section-label">Main</div>
          {visibleItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              // Spec 050 — the screen key is the stable handle for tests and for
              // anyone reasoning about which entries a role grants. Asserting on
              // the rendered text would pick up the icon glyph too.
              data-screen={navScreens(item)[0] ?? 'admin-roles'}
              className={`admin-nav-item${location.pathname.startsWith(item.to) ? ' active' : ''}`}
            >
              <span className="admin-nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </aside>
  );
}
